import { useParams } from 'react-router-dom';
import { ConfiguratorLogic, ConfiguratorViewContext } from '../app/configurator-logic'
import { ConfiguratorRoot } from '../view/configurator-root'
import { ErrorPage } from './error-page';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { configuratorActions } from '../app/configurator-slice';
import { useEffect } from 'react';
import { LoadingPage } from './loading-page';
import { langSelector } from '../app/main-slice';
import { useMessages2 } from '../hooks/useLanguage';
import { CatalogLogic } from '../app/catalog-logic';
import { useFamilyName, useVariantName } from '../hooks/navigation-names';
import { PageMetadata } from '../view/page-metadata';

export const ConfiguratorPage = () => {

    const { categoryId, familyId, variantId } = useParams();
    // a little "cheesy": this is not set if not initialized
    const lang = useAppSelector(langSelector);
    const {isLoading: isLoadingMessage, isError: isErrorMessage, messages } = useMessages2();

    let content;

    if(!lang || !categoryId || !familyId || isErrorMessage) {
        content = <ErrorPage />
    } else if(!lang || isLoadingMessage) {
        content = <LoadingPage />
    } else {
        content = <CatalogLogic error={() => <ErrorPage />} loading={() => <LoadingPage />}>
            <ConfiguratorLogic>
                <ConfiguratorRoot />
            </ConfiguratorLogic>
        </CatalogLogic>
    }

    const familyName = useFamilyName(categoryId!, familyId!);
    const variantName = useVariantName(familyId!, variantId!);
    const productName = variantName ? `${familyName} - ${variantName}` : `${familyName}`;

    return <>
        <PageMetadata pageTitle={productName} />
        { content }
    </>

}